import { HeadCell } from 'components/molecules/DataTable/TableHeader'

export const prefCardHeadCells: HeadCell[] = [
  {
    id: 'surgeon',
    label: 'Surgeon name',
    numeric: true,
    sx: {
      width: '20%',
    },
  },
  {
    id: 'procedure',
    label: 'Procedure type',
    numeric: false,
    sx: {
      width: '30%',
    },
  },
  {
    id: 'name',
    label: 'Name',
    numeric: false,
    sx: {
      width: '30%',
    },
  },
  {
    id: 'actions',
    label: 'Actions',
    numeric: false,
    sx: {
      width: '20%',
    },
  },
]

export const proceduresHeadCells: HeadCell[] = [
  {
    id: 'date',
    label: 'Date',
    numeric: true,
    sx: {
      minWidth: '10%',
      width: '20%',
    },
  },
  {
    id: 'surgeon',
    label: 'Surgeon name',
    numeric: true,
  },
  {
    id: 'procedure',
    label: 'Procedure type',
    numeric: false,
  },
  {
    id: 'preferenceCard',
    label: 'Preference Card',
    numeric: false,
  },
  {
    id: 'actions',
    label: 'Actions',
    numeric: false,
  },
]
